import { useCallback, useState } from 'react'
import { currencies } from './CurrencySelector.data'

/** Modal open state plus the option matching the active currency code. */
export function useCurrencySelectorController(code: string) {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = useCallback(() => setIsOpen(true), [])
  const closeModal = useCallback(() => setIsOpen(false), [])

  const current = currencies.find((option) => option.code === code) ?? currencies[0]

  return { isOpen, current, openModal, closeModal }
}
